import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { PagetitleService } from '../../../services/pageTitle/page-title.service';
import { LookupsStore } from '../../../store/lookups.store';
import { TSeoKeys } from '../../interfaces';

export const pageTitleResolver: ResolveFn<boolean> = (route, state) => {
  const lookupsStore = inject(LookupsStore);
  const pageTitleService = inject(PagetitleService);
  const seoData = route.data['seoData'] as TSeoKeys;
  const data: string = seoData || route.data['title'] || 'Lokinter';
  const isSeoData = !!seoData;
  const title = isSeoData ? lookupsStore.blocks()?.seo?.[seoData].title : data;
  const description = isSeoData ? lookupsStore.blocks()?.seo?.[seoData].description : data;
  pageTitleService.setTitle({ title: title ?? '', description: description ?? '' }, route, state);
  return true;
};
